import React from 'react';

const About = () => (
  <section id="sobre-mi" className="bg-paper-dim py-24 md:py-32">
    <div className="max-w-[1100px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-12 md:gap-20 items-center">
      <div className="order-2 md:order-1">
        <img
          src="/foto-seba.jpg"
          alt="Sebastian Chuffer"
          loading="lazy"
          className="w-full h-auto grayscale hover:grayscale-0 transition-all duration-1000"
        />
      </div>
      <div className="order-1 md:order-2">
        <p className="text-[11px] tracking-[0.42em] uppercase text-muted mb-4">Sobre mí</p>
        <h2 className="font-display font-bold text-3xl md:text-4xl tracking-tight mb-8">Sebastian Chuffer</h2>
        <div className="space-y-5 font-serif text-[17px] leading-relaxed text-ink/80">
          <p>
            Fotógrafo por instinto, creador por necesidad, explorador del límite entre lo que es y lo que
            podría ser. Mis fotos buscan capturar eso que el ojo suele pasar por alto: lo invisible de lo
            cotidiano, lo fugaz del instante, lo que vibra detrás de lo evidente.
          </p>
          <p>
            Viajar, para mí, es una forma de atención. Una manera de estar presente. Cada imagen es un
            fragmento de esa presencia: una luz, una textura, un encuentro.
          </p>
          <p>Esta web es mi galería viva. Una invitación a mirar distinto.</p>
        </div>
      </div>
    </div>
  </section>
);

export default About;
